import { TABLE_NO_DATA_CELL } from '../constants/data';

export const renderDate = (date: string | Date | undefined, defaultValue: string = TABLE_NO_DATA_CELL) =>
  date
    ? new Date(date)?.toLocaleDateString('es-Ar', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : defaultValue;
